import { ICanReject } from './types';
import { REJECT_LEAD_AUTH, UPDATE_PERMISSION } from 'src/constants/permissions';
import { isPermissionGranted } from 'src/utils/permissions/isPermissionGranted';

/**
 * Will return if user can reject a lead
 *
 * @return {*}  {boolean}
 */
export const canReject = ({ permissions }: ICanReject): boolean => {
    return isPermissionGranted({
        permissions: permissions,
        permission: REJECT_LEAD_AUTH,
        crud: UPDATE_PERMISSION,
    });
};
